exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Backdrop__Backdrop--eeZpu{\r\n\tz-index: 50;\r\n\tbackground-color: rgba(0,0,0,.7);\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tright:0;\r\n\tleft:0;\r\n}", ""]);

// exports
exports.locals = {
	"Backdrop": "Backdrop__Backdrop--eeZpu"
};